import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface GuestParticipantListItem {
  id: string;
  name: string;
  initial: string;
  description: string;
  muted?: boolean;
}

@Component({
  selector: "app-guest-participant-list",
  templateUrl: "./guest-participant-list.component.html",
  styleUrls: ["./guest-flow.component.css"],
  standalone: false
})
export class GuestParticipantListComponent {
  @Input() public items: GuestParticipantListItem[] = [];
  @Input() public clickable = false;
  @Input() public showChevron = false;

  @Output() public itemClick = new EventEmitter<GuestParticipantListItem>();
}
